import { useWorkspaces } from "@/hooks/useWorkspaces";
import { CategoryTreeService } from "@/services/categoryTree/categoryTree.service";

export function useCategoryTrees() {
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  const { data, error, isLoading, mutate } = CategoryTreeService.getCategoryTrees(sessionCurrentWorkspaceId);

  const getCategoryTree = (categoryTreeId: string) => data?.find((categoryTree) => categoryTree.id === categoryTreeId);

  const getCategoryTreeVersion = (categoryTreeId: string) => getCategoryTree(categoryTreeId)?.version;

  return {
    categoryTrees: data,
    error,
    isLoading,
    getCategoryTree,
    getCategoryTreeVersion,
    mutate,
  };
}
